import React from 'react';
import { propertyImages, type PropertyKey } from '../../data/propertyImages';
import type { Lang } from '../../types/funnel';
interface PropertyPhotoProps {
  property: PropertyKey;
  lang: Lang;
  className?: string;
  priority?: boolean;
  /** Decorative inside a labeled button. */
  decorative?: boolean;
}
export function PropertyPhoto({
  property,
  lang,
  className = '',
  priority,
  decorative
}: PropertyPhotoProps) {
  const p = propertyImages[property];
  return <img src={p.url} alt={decorative ? '' : p.alt[lang]} width={1200} height={900} loading={priority ? 'eager' : 'lazy'} decoding="async" className={`bg-ink-100 object-cover ${className}`} data-id="element-582" data-mp="2w00nbd4vfudf" />;
}